export default __webpack_public_path__ + "static/media/coins.5c18221c.png";